'use strict'

function rectangular (i,N) {
  return 1
}

module.exports = rectangular
